import Vue from 'vue'
import Router from 'vue-router'

//componets
import Hello from '@/components/Hello';
import Main from '@/components/main/Main';
import Login from '@/components/login/Login';
import Settings from '@/components/settings/Settings';
import AlertMessaging from '@/components/settings/categories/AlertMessaging';
import AudioRecording from '@/components/settings/categories/AudioRecording';
import Delete from '@/components/settings/categories/Delete';
import Device from '@/components/settings/categories/Device';
import Download from '@/components/settings/categories/Download';
import DynamicDns from '@/components/settings/categories/DynamicDns';
import FTPSending from '@/components/settings/categories/FTPSending';
import GeoPos from '@/components/settings/categories/GeoPos';
import Interface from '@/components/settings/categories/Interface';
import Status from '@/components/settings/categories/Status';
import Weather from '@/components/settings/categories/Weather';
import Video from '@/components/settings/categories/Video';
import Adio from '@/components/settings/categories/Adio';
import NorCloud from '@/components/settings/categories/NorCloud';
import Statistics from '@/components/settings/categories/Statistics';


import Archive from '@/components/settings/Archive';

import Graphs from '@/components/graphs/Graphs'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Main',
			component: Main,
			children:[
				{
					path:'',
					component: Graphs,
				},
				{
					path:'/statistics',
					component: Graphs
				},
				{
					path:'/realtime',
					component: Graphs,
				},
				{
					path:'/archives/:type/',
					component:Archive,
				},
				{
					path:'/archives/:type/:day',
					component:Archive,
				},
				{
					path:'/settings',
					name:'settings',
					component:Settings,
					children:[
						{
							path:'/settings/alertMessaging',
							component:AlertMessaging
						},
						{
							path:'/settings/audioRecording',
							component:AudioRecording
						},
						{
							path:'/settings/delete',
							component:Delete
						},
						{
							path:'/settings/device',
							component:Device
						},
						{
							path:'/settings/download',
							component:Download
						},
						{
							path:'/settings/dynamicDns',
							component:DynamicDns
						},
						{
							path:'/settings/FTPSending',
							component:FTPSending
						},
						{
							path:'/settings/geographicPosition',
							component:GeoPos
						},
						{
							path:'/settings/interface',
							component:Interface
						},
						{
							path:'/settings/status',
							component:Status
						},
						{
							path:'/settings/weather',
							component:Weather
						},
						{
							path:'/settings/video',
							component:Video
						},
						{
							path:'/settings/adio',
							component:Adio
						},
						{
							path:'/settings/norcloud',
							component:NorCloud
						},
						{
							path:'/settings/statistics',
							component: Statistics
						}
					]
				}
			]
		},
		{	
			path: '/login',
			name: 'login',
			component: Login
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js